<template>
  <b-card no-body>
    <b-card-header class="pb-50">
      <h5>Filters</h5>
    </b-card-header>
    <b-card-body>
      <b-row>
        <b-col cols="12" md="3" class="mb-md-0 mb-2">
          <label>Booking Stage</label>
          <v-select
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :value="bookingstageFilter"
            :options="bookingstageOptions"
            label="stage"
            class="w-100"
            :reduce="(val) => val.id"
            @input="(val) => $emit('update:bookingstageFilter', val)"
          >
            <template #option="{ stage, background_color }">
              <div
                class="rounded-circle d-inline-block mr-50 bg-primary"
                :style="{
                  background: background_color + ' !important',
                  height: '10px',
                  width: '10px',
                }"
              />
              <span> {{ stage }}</span>
            </template>

            <template #selected-option="{ stage, background_color }">
              <div
                class="rounded-circle d-inline-block mr-50 bg-primary"
                :style="{
                  background: background_color + ' !important',
                  height: '10px',
                  width: '10px',
                }"
              />
              <span> {{ stage }}</span>
            </template>
          </v-select>
        </b-col>
        <b-col cols="12" md="3" class="mb-md-0 mb-2">
          <label>Customer</label>
          <v-select
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :value="customerFilter"
            :options="customerOptions"
            label="name"
            class="w-100"
            :reduce="(val) => val.id"
            @input="(val) => $emit('update:customerFilter', val)"
          />
        </b-col>
        <b-col cols="12" md="3" class="mb-md-0 mb-2">
          <label>Coach</label>
          <v-select
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :value="coachFilter"
            :options="coachOptions"
            label="coach_name"
            class="w-100"
            :reduce="(val) => val.id"
            @input="(val) => $emit('update:coachFilter', val)"
          />
        </b-col>
        <b-col cols="12" md="3" class="mb-md-0 mb-2">
          <label></label>
          <div>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              size="sm"
              variant="primary"
              @click="reset"
              style="height: 40px"
            >
              Reset
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardBody,
  BRow,
  BCol,
  BFormDatepicker,
  BButton,
} from "bootstrap-vue";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";

export default {
  directives: {
    Ripple,
  },
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    vSelect,
    BFormDatepicker,
    BButton,
  },
  methods: {
    reset() {
      this.$emit("update:bookingstageFilter", null);
      this.$emit("update:customerFilter", null);
      this.$emit("update:coachFilter", null);
    },
    // clientSearch(options, search){
    //   var returnOptions = options.filter(item => {
    //     return item.client_code.toLowerCase().includes(search.toLowerCase()) || item.company_name.toLowerCase().includes(search.toLowerCase())
    //   })
    //     return returnOptions
    // }
  },
  props: {
    bookingstageFilter: {
      type: [Number, null],
      default: null,
    },
    coachFilter: {
      type: [Number, null],
      default: null,
    },
    customerFilter:{
      type: [Number, null],
      default: null
    },
    coachOptions:{
        type: Array,
        required: true,
    },
    bookingstageOptions: {
      type: Array,
      required: true,
    },
    customerOptions:{
      type: Array,
      required: true,
    }
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
